import { createAuditLogPage } from './kernelAuditLog';

// Entità che compaiono nel registro (filtro e colonna "Entità"). Le azioni fatte da Claude hanno
// il riepilogo che comincia con "[Via Claude]" (cercabile dal campo di ricerca).
const ENTITIES = ['company', 'user', 'ticket', 'ticket_comment', 'ticket_project', 'ticket_project_field', 'project', 'claude_token', 'claude_settings'];

const entityLabels = {
  company: 'Azienda',
  user: 'Utente',
  ticket: 'Ticket',
  ticket_comment: 'Messaggio del ticket',
  ticket_project: 'Coda di assistenza',
  ticket_project_field: 'Campo del modulo',
  project: 'Progetto',
  claude_token: 'Token Claude',
  claude_settings: 'Impostazioni Claude',
};

export default createAuditLogPage(ENTITIES, { entityLabels });
